module.exports = __webpack_public_path__ + "img/arrow-left-hover.a0d00e91.svg";